import moment from "moment-timezone";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export const formatWithDollar = (value: string) => {
  return /^\d+$/.test(value) ? `$${value}` : value;
};

export const formatTitleCase = (str: string) => {
  if (!str) return "-";
  return str
    .replace(/_/g, " ") // Replace underscores with spaces
    .toLowerCase() // Convert entire string to lowercase
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
};

export const handleUnlimited = (value: any) => {
  return value == -1 ? "Unlimited" : value;
};
export const capitalizeFirstLetter = (word: string) => {
  if (!word) return "";
  return word.charAt(0).toUpperCase() + word.slice(1);
};

export const splitPhoneNumber = (
  formatSentFromDB: string | null | undefined
) => {
  if (!formatSentFromDB) {
    return {
      countryCode: "+1", // Default country code
      phoneNumber: "",
    };
  }

  const contactNumberRegex = /^(\+\d{1,4})[-\s]?(\d{6,15})$/;
  const match = formatSentFromDB.match(contactNumberRegex);

  return match
    ? {
        countryCode: match[1], // Country code (e.g., +1)
        phoneNumber: match[2], // Phone number without country code
      }
    : {
        countryCode: "", // Empty if invalid format
        phoneNumber: "",
      };
};

export const concatenatePhoneNumber = (phoneNumberFormatValues: any) => {
  const { countryCode, phoneNumber } = phoneNumberFormatValues;
  if (!countryCode && !phoneNumber) {
    return "";
  }
  return `${countryCode}-${phoneNumber}`;
};

export const validateImageDimensions = (
  file: any,
  maxWidth: number,
  maxHeight: number
): Promise<boolean> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const { width, height } = img;
      resolve(width <= maxWidth && height <= maxHeight);
    };
    img.onerror = () => {
      resolve(false);
    };
    img.src = URL.createObjectURL(file);
  });
};
export const formatDateTime = (dateString: string, day?: boolean): string => {
  const date = moment.utc(dateString).tz(moment.tz.guess());
  

  if (day) {
   return date.format("dddd, MMMM D YYYY, h:mm A");
  }

  

  return date.format("MMMM D, YYYY h:mm A");
};
export const formatDateOnly = (dateString: string): string => {
  const date = moment.utc(dateString).tz(moment.tz.guess());
  return date.format("MMMM D, YYYY");
}
export const isOnlyCountryCode = (
  value: string | undefined | null
): boolean => {
  if (!value) return false;

  const formattedValue = value.trim();
  // Check if the value is just a country code (e.g., +1 or +91)
  return /^(\+\d{1,3})$/.test(formattedValue);
};

export const extractCountryAndNumber = (number: any) => {
  if (!number) return null;
  const match = number.trim().match(/^(\+\d{1,4})\s*(.*)$/);

  if (!match) return null;

  return {
    countryCode: match[1],
    number: match[2].replace(/[-]/g, ""), // remove dashes
  };
};

export const formatDate = (dateString: string | null | undefined) => {
  if (!dateString) return "-";
  const date = moment.utc(dateString).tz(moment.tz.guess());
  const month = String(date.month() + 1).padStart(2, "0");
  const day = String(date.date()).padStart(2, "0");
  const year = date.year();
  return `${month}/${day}/${year}`;
};

export const formatTime = (dateString: string | null | undefined) => {
  if (!dateString) return "-";
  return moment.utc(dateString).tz(moment.tz.guess()).format("hh:mm A"); // Formats to 12-hour time with AM/PM
};
export const getCombinedDateTime = (date: any, time: any) => {
  if (!date || !time) return null;

  return dayjs(date)
    .hour(dayjs(time).hour())
    .minute(dayjs(time).minute())
    .second(0)
    .millisecond(0)
    .toISOString();
};

// src/utils/get-current-tenant-id.ts

export const getCurrentTenantId = (): number | null => {
  try {
    const loginData = localStorage.getItem("loginData");
    if (!loginData) return null;

    const parsedData = JSON.parse(loginData);
    const id = parsedData?.tenantDetails?.id;

    // return typeof id === "number" ? id : (Number.isNaN(Number(id)) ? null : Number(id));
    return typeof id === "number" ? id : Number(id) || null;
  } catch (error) {
    console.error("Failed to parse loginData from localStorage:", error);
    return null;
  }
};

export const convertUTCToLocal = (
  utcDateString: string,
  format: string = "YYYY-MM-DD hh:mm:ss A"
) => {
  return moment.utc(utcDateString).tz(moment.tz.guess()).format(format);
};

export const convertUTCToLocalRelative = (utcDateString: string) => {
  return moment.utc(utcDateString).tz(moment.tz.guess()).fromNow();
};

export const convertToMinutes = (timeStr: string): number => {
  if (!timeStr || timeStr === "00:00:00") {
    return 0;
  }
  const [hours, minutes, seconds] = timeStr.split(":").map(Number);
  return hours * 60 + minutes + Math.floor(seconds / 60);
}
export const formatTypeWithRegex = (resourceName: string) => {
    if (!resourceName) return "-";
    return resourceName.replace(/([a-z])([A-Z])/g, '$1 $2');
};